module.exports = __webpack_public_path__ + "images/bannerEN-7bf3a5c58a87d8309f498f2c796f0ff4.png";